<template>
	<div
		:class="{
			'sports-list-item': $store.getters.layout == 'Mobile',
			'disable-select': $store.getters.layout == 'Mobile',
		}"
		oncontextmenu="return false;"
	>
		<!--		Items from sports endpoint response-->
		<div
			v-if="sport.hard_coded == false"
			:class="routerLinkClass"
			v-longpress="toggleEdit"
			@click="close($event, sport.sport_id)"
		>
			<sport-icon :sport="sport" class="sports-list__item__icon" />
			<span :class="spanClass">{{ sport.sport_name }}</span>
		</div>

		<!--		Hard Coded Items Without external link-->
		<div
			v-if="
				sport.hard_coded == true &&
					sport.external_link == false &&
					productAvailable(sport.sport_name) &&
					$store.getters.layout == 'Mobile'
			"
			style="position: relative"
			:class="routerLinkClass"
			v-longpress="toggleEdit"
			@click="close($event, sport.sport_id)"
			@contextmenu.prevent="doNothing"
		>
			<new-badge
				v-if="sport.new_badge && !hasNewBannerExpired"
				class="new-badge"
				style=""
			/>
			<img
				v-if="sport.image != null"
				:src="`${sport.image}`"
				class="sports-list__item__icon"
			/>
			<sport-icon
				v-if="sport.image == null"
				:sport="{ sport_name: sport.sport_name }"
				class="sports-list__item__icon"
			/>
			<span :class="spanClass"
				>{{ sport.label }}
				{{
					sport.label === "Promotions" && recCount !== 0
						? `(${recCount})`
						: null
				}}
			</span>
		</div>

		<!--		HardCoded Items With External Link-->
		<div
			v-if="
				sport.hard_coded == true &&
					sport.external_link == true &&
					productAvailable(sport.sport_name) &&
					$store.getters.layout == 'Mobile'
			"
			style="position: relative"
			:class="routerLinkClass"
			@click="close($event, null)"
		>
			<sport-icon
				:sport="{ sport_name: sport.sport_name }"
				class="sports-list__item__icon"
			/>
			<span :class="spanClass">{{ sport.label }}</span>
		</div>
	</div>
</template>

<script>
import NewBadge from "../Shared/NewBadge.vue";
import isPast from "date-fns/isPast";
import parse from "date-fns/parse";
import featureFlagsMixin from "../../utils/mixins/featureFlags.mixin";

export default {
	name: "SportsListItem",
	mixins: [featureFlagsMixin],
	components: { NewBadge },
	props: {
		itemRef: String,
		sport: Object,
		selectedSport: Object,
		routeTo: Object,
		routerLinkClass: Object,
		spanClass: Object,
		draggingDisabled: Boolean,
	},
	computed: {
		loggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		hasNewBannerExpired() {
			let vm = this;
			const dateRegex = "^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$";
			const dateTimeRegex =
				"^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])\\s(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$";
			const expiryDate = vm.sport.expiry;
			if (expiryDate == null) {
				return true;
			}
			if (expiryDate.isMatch(dateRegex)) {
				return isPast(parse(expiryDate, "yyyy-MM-dd", new Date()));
			} else if (expiryDate.isMatch(dateTimeRegex)) {
				return isPast(parse(expiryDate, "yyyy-MM-dd HH:mm", new Date()));
			} else {
				return true;
			}
		},
		recCount() {
			let vm = this;
			const getRecs = vm.$store.getters["promos/list"];

			if (getRecs.length !== 0) {
				return getRecs[0].promoData.length;
			}
			return 0;
		},
	},
	methods: {
		close(event, sportId) {
			let vm = this;
			vm.$emit("close", event, sportId);
			vm.goToPath();
		},
		toggleEdit() {
			let vm = this;
			vm.$emit("toggleEdit");
		},
		doNothing() {
			return false;
		},
		goToPath() {
			let vm = this;
			if (vm.draggingDisabled == true) {
				// Will navigate only when not in edit mode
				if (vm.sport.hard_coded == false) {
					vm.$router.push({
						name: "sport",
						params: {
							sportName: vm.$options.filters.seoText(vm.sport.sport_name),
						},
					});
				} else if (
					vm.sport.hard_coded == true &&
					vm.sport.external_link == false
				) {
					let params = vm.sport.params;
					let queryParams = vm.sport.query_params;
					// For jackpots on mobile, check login + feature flag to determine route
					// if (vm.sport.sport_name === "jackpots" && vm.$store.getters.layout == "Mobile") {
					// 	const isMustBeWonEnabled = vm.loggedIn && vm.isFeatureOn('JACKPOT_MUST_BE_WON');
					// 	const defaultJackpot = this.env.jackpots.find(jackpot => jackpot.id === this.env.defaultJackpotId);
					// 	const routeName = isMustBeWonEnabled ? "must-be-won" : defaultJackpot.routeName;
					// 	vm.$router.push({
					// 		name: routeName,
					// 		query: queryParams,
					// 		params: params
					// 	});
					// } else {
						vm.$router.push({
							path: vm.sport.route,
							query: queryParams,
							params: params
						});
					// }
				} else if (
					vm.sport.hard_coded == true &&
					vm.sport.external_link == true
				) {
					window.open(vm.sport.route);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.sports-list-item {
	padding: 0px;
	margin: 0px;
	//min-width: 55px;
	//overflow: hidden;
}
.disable-select {
	user-select: none; /* supported by Chrome and Opera */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
}
//@media (max-width: 280px) {
//	width: 50px;
//}
//@media(min-width: 281px) and (max-width: 320px) {
//	width: fit-content;
//}
//@media (min-width: 321px) and (max-width: 360px) {
//	width: fit-content;
//}
//@media (min-width: 361px) and (max-width: 375px) {
//	width: min-content;
//}
//@media (min-width: 376px) {
//	width: content-box;
//}
//@media (min-width: 469px) and (max-width: 1022px) {
//	grid-template-columns: repeat(auto-fill, max(80px));
//	column-gap: 10px;
//}
</style>
